module.exports = __webpack_public_path__ + "img/container-storage.9daab5b0.svg";